import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Signup from "./Signup";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword"; // ✅ NEW
import UserDashboard from "./UserDashboard";
import GraderDashboard from "./GraderDashboard";
import SubmitForm from "./SubmitForm";
import Wallet from "./Wallet";
import Orders from "./Orders";
import Profile from "./Profile";
import OrderDetails from "./OrderDetails";
import GraderReview from "./GraderReview";
import SubmissionFeedback from "./SubmissionFeedback";
import Shop from "./Shop";
import LandingPage from "./LandingPage";
import VerifyEmail from "./VerifyEmail";
import VerifyConfirm from "./VerifyConfirm";
import Pricing from "./Pricing";
import Contact from "./Contact";
import TermsOfService from "./TermsOfService";
import PurchaseHistory from "./PurchaseHistory";
import WhatWeEvaluate from "./WhatWeEvaluate";
import FAQs from "./FAQs";
import BlogPost from "./components/BlogPost";
import CenteringToolPage from "./CenteringToolPage"; // ✅ NEW

import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        await currentUser.reload();
      }
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) return null;

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            user && user.emailVerified
              ? <Navigate to="/user-dashboard" replace />
              : <LandingPage />
          }
        />

        {/* Auth & dashboards */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} /> {/* ✅ Added */}
        <Route path="/user-dashboard" element={<UserDashboard />} />
        <Route path="/grader-dashboard" element={<GraderDashboard />} />
        <Route path="/review/:submissionId" element={<GraderReview />} />

        {/* Core app */}
        <Route path="/submit" element={<SubmitForm />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/shop" element={<Shop />} /> {/* ✅ Added route for Shop */}
        <Route path="/orders" element={<Orders />} />
        <Route path="/orders/:id" element={<OrderDetails />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/purchase-history" element={<PurchaseHistory />} />
        <Route path="/feedback/:id" element={<SubmissionFeedback />} />

        {/* Email verification */}
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/verify-confirm" element={<VerifyConfirm />} />

        {/* Marketing / info */}
        <Route path="/products" element={<div style={{ padding: 40 }}><h2>Products Page</h2></div>} />
        <Route path="/what-we-authenticate" element={<div style={{ padding: 40 }}><h2>What We Authenticate</h2></div>} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/more" element={<div style={{ padding: 40 }}><h2>More Info Page</h2></div>} />
        <Route path="/search-certificate" element={<div style={{ padding: 40 }}><h2>Search Certificate</h2></div>} />
        <Route path="/what-we-evaluate" element={<WhatWeEvaluate />} />
        <Route path="/faqs" element={<FAQs />} />

        {/* Legal */}
        <Route path="/terms-of-service" element={<TermsOfService />} />

        {/* Blog */}
        <Route path="/blog/:slug" element={<BlogPost />} />

        {/* ✅ Stand-alone Centering Tool */}
        <Route path="/centering-tool" element={<CenteringToolPage />} />
      </Routes>
    </Router>
  );
}

export default App;
